module.exports = __webpack_public_path__ + "static/media/qixingshanadj.37fffb49.png";